<template>
    <h3 class="text-uppercase mb-4">{{blok.headline}}</h3>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>